import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: `${theme.spacing(5)}px ${theme.spacing(5)}px`,
    backgroundColor: '#FCF9F8',
    height: '100%'
  },
  wrapper: {
    height: '100%'
  },
  menuItem: {
    fontFamily: 'National',
    fontSize: 16
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `${theme.spacing(2.5)}px ${theme.spacing(3)}px`,
    width: '100%',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF'
  },
  divider: {
    height: '1px',
    border: '1px solid #E4E8F1',
    margin: `${theme.spacing(2)}px 0`,
    width: '100%'
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#FFFFFF',
    height: '100%'
  },
  nonDefault: {
    marginRight: theme.spacing(2.5),
    '& > div': {
      border: '1px solid #F7901E'
    }
  },
  dropdownSelect: {
    marginRight: theme.spacing(2.5)
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
    flexBasis: 'auto'
  },
  label: {
    fontWeight: 400
  },
  generateReel: {
    marginLeft: 'auto',
    backgroundColor: '#E4E8F1',
    width: '180px',
    height: '40px',
    letterSpacing: '2px',
    fontWeight: 'bold'
  },
  clearFilters: {
    marginLeft: theme.spacing(3),
    color: '#8688A1',
    fontFamily: 'National',
    fontSize: '10px',
    fontWeight: 500,
    letterSpacing: '2px',
    lineHeight: '13px',
    '& > span > span': {
      marginLeft: 0
    }
  },
  tagBank: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexBasis: 'auto'
  },
  tagBankHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexBasis: 'auto'
  },
  firstColumn: {
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      marginLeft: theme.spacing(1)
    },
    '& > span': {
      marginLeft: 'auto',
      marginRight: theme.spacing(10)
    }
  },
  middleColumn: {
    display: 'flex',
    alignItems: 'center',
    '& > img': {
      marginLeft: theme.spacing(4)
    },
    '& > div': {
      marginLeft: theme.spacing(1)
    },
    '& > span': {
      marginLeft: 'auto',
      marginRight: theme.spacing(5)
    }
  },
  lastColumn: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& > div': {
      marginLeft: theme.spacing(1),
      marginRight: 'auto'
    },
    '& > img': {
      marginLeft: theme.spacing(8)
    }
  },
  tagBankButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#F7901E',
    transition: 'none',
    '& > span > span': {
      marginLeft: 0
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  arrow: {
    color: '#8688A1',
    width: '28px',
    height: '28px'
  },
  totalStories: {
    color: '#8688A1',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  tagCheckbox: {
    '& > span > svg': {
      fill: '#8688A1'
    }
  },
  tagName: {
    opacity: 0.9
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(10, 20)
  },
  icon: {
    marginBottom: '4px'
  },
  header: {
    color: '#8688A1',
    marginBottom: '8px'
  },
  text: {
    fontSize: '14px',
    letterSpacing: 0,
    lineHeight: '21px',
    color: '#8688A1',
    fontWeight: 'normal',
    textAlign: 'center'
  }
}))
